import flow from "lodash/fp/flow";
import reverse from "lodash/fp/reverse";
import map from "lodash/fp/map";
import moment from "moment";
import constants from "../../core/constants";
import { toObject, parsePrice } from "../../core/utils";
import find from "lodash/fp/find";

class InvoiceItemPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists;
  }

  justify(data) {
    const formatDate = (item) => {
      item.date = moment(item.date).format(constants.dateTimeFormat);
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);

      return item;
    };

    const formatCashStatus = (item) => {
      const findCashCollectionStatus = (listItem) =>
        item.cash_collection_status === listItem.name;
      const cashCollectionStatusObj = find(findCashCollectionStatus)(
        this.Lists.cashCollectionStatus
      );
      item.cashCollectionStatus = cashCollectionStatusObj;
      return item;
    };

    const formatAmount = (item) => {
      item.amount = parsePrice(item.amount);

      return item;
    };

    const formatNotes = (item) => {
      const namingFormat = (note) =>
        Object.assign(
          {},
          { comment: note.body, createdBy: note.operator },
          note
        );
      const formatDate = (note) => {
        note.createdAt = moment(note.createdAt.value).format(
          constants.dateTimeFormat
        );

        return note;
      };
      item.notes = reverse(
        map(flow([toObject, namingFormat, formatDate]))(item.notes)
      );

      return item;
    };

    const formatType = (item) => {
      item.typeKey = item.type && item.type.key;
      item.type = item.name;

      return item;
    };
    return flow([
      formatDate,
      formatAmount,
      formatType,
      formatNotes,
      formatCashStatus,
    ])(data);
  }
}

export default InvoiceItemPageTransform;



// WEBPACK FOOTER //
// ./src/pages/invoiceItem/invoiceItem.transforms.js